import React, { useEffect } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { withRouter, Redirect } from "react-router-dom"
import queryString from "query-string"
import Helmet from "react-helmet"
import { updateAccount, signUp } from "@api/account"
import { getSubscriptionPrice } from "@api/prices"
import CreditCardForm from '@src/pages/settings/pages/billing/components/add/form'
import { Status } from "@bitcine/cs-theme"
import Address from "./address"
import SignUpForm from "./signup_form"

const perks = [
  '1TB of storage',
  '20 monthly studio-grade DRM-encoded screeners',
  'Screener rooms and analytics',
  'Aspera file requests',
  '... and so much more!'
]

const Payment = ({ price, getSubscriptionPrice, fetchingPrice, account, card, updateAccount, signUp, submitting, error, location, history }) => {
  const googleID = queryString.parse(window.location.search).googleID || null
  const countryCode = queryString.parse(window.location.search).countryCode || account.country_code || 'US'
  useEffect(() => {
    if (googleID) {
      updateAccount({
        googleID,
        country_code: queryString.parse(window.location.search).countryCode,
        email: queryString.parse(window.location.search).email,
        full_name: queryString.parse(window.location.search).fullName,
      })
    }
  }, [updateAccount, googleID])
  const unset = !googleID && (!account.email || !account.full_name || !account.password || !account.country_code)
  useEffect(() => {
    getSubscriptionPrice({ countryCode })
  }, [countryCode, getSubscriptionPrice])

  if (fetchingPrice) {
    return <Status pending/>
  }

  return (
    <>
      <Helmet title='CineSend | Sign Up'/>
      {unset && <Redirect to='/signup'/>}
      <form>
        <div className={'mb3 pb3 border-gray-5 border-bottom'}>
          <SignUpForm
            festival={false}
            showButton={false}
          />
        </div>
        <h4 className={'center border-gray-5 border-bottom mb1 pb2'}>Sign up today for {price.interval_amount_formatted}</h4>
        <div className={'fs12 bold italic mb1'}>Your subscription includes:</div>
        {perks.map((perk, i) => <li className='fs12' key={i}>{perk}</li>)}
        <div className={'border-gray-5 border-top mt1 pt2'}/>
        <CreditCardForm newPaymentMethod={'credit-card'}/>
        <Address/>
        {error && <div className={'my1 red bold'}>
          {error}
        </div>}
        <div className={'fs12 muted my1'}>By signing up you agree to the <a rel="noopener noreferrer" className="bold underline" href='https://cinesend.com/terms-and-conditions' target='_blank'>Terms and Conditions.</a></div>
        <button
          id='cinesend-final-sign-up-button'
          type='submit'
          tabIndex='1'
          data-test-id='account-submit-btn'
          onClick={event => {
            event.preventDefault()
            event.stopPropagation()
            signUp(googleID)
          }}
          disabled={submitting
            || !account.address_line1
            || !account.postal_code
            || !account.mobile_number
            || account.status === "PENDING"
            || [
              "credit_card_cardholder_name",
              "credit_card_card_number",
              "credit_card_cvc",
              "credit_card_expiry"
            ].filter(key => !card[key]).length > 0}
          className={`cs-button ${account.status.toLowerCase()} col-12 cinesend-final-sign-up-button`}>
          Sign up for {price.interval_amount_formatted}
        </button>
      </form>
    </>
  )
}

const mapStateToProps = state => ({
  account: state.account,
  card: state.settings.billing.new,
  fetchingPrice: state.prices.subscription.status === 'PENDING',
  price: state.prices.subscription.price.monthly,
  submitting: state.account.status === 'PENDING',
  error: state.account.error_message
})

const mapDispatchToProps = dispatch => ({
  updateAccount: bindActionCreators(updateAccount, dispatch),
  signUp: bindActionCreators(signUp, dispatch),
  getSubscriptionPrice: bindActionCreators(getSubscriptionPrice, dispatch)
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Payment))